var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlertModalIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 67,
    viewBox: "0 0 66 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5.67676,
    width: 56,
    height: 56,
    rx: 28,
    fill: "#F04438"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5.67676,
    width: 56,
    height: 56,
    rx: 28,
    stroke: "#D92D20",
    strokeWidth: 10
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.9999 29.0098V33.6764M32.9999 38.3431H33.0116M44.6666 33.6764C44.6666 40.1198 39.4432 45.3431 32.9999 45.3431C26.5566 45.3431 21.3333 40.1198 21.3333 33.6764C21.3333 27.2331 26.5566 22.0098 32.9999 22.0098C39.4432 22.0098 44.6666 27.2331 44.6666 33.6764Z",
    stroke: "white",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertModalIcon);
export default __webpack_public_path__ + "static/media/alertModalIcon.404d2c72da3dd1ed3f1562f930149cf4.svg";
export { ForwardRef as ReactComponent };